import { useRouter } from "next/router";
import { LogoWrapper } from "styles/jss/Navigation.styles";
import { DrawerTopMenuWrapper } from "styles/jss/NavDrawer.styles";
import NextImage from "components/NextImage";
import CloseIcon from "components/IconsSvg/CloseIcon";
import SearchInput from "components/Search/SearchInput";

export default function DrawerTopMenu({ logos, toggleDrawer }) {
  const { locale } = useRouter();
  const alt =
    locale === "fa" ? "شرکت پلیمر آریاساسول" : "Arya Sasol Polymer Company";

  return (
    <DrawerTopMenuWrapper>
      <div className={"logoWrapper"}>
        <LogoWrapper className={"logo"}>
          <NextImage
            layout={"responsive"}
            width={170}
            height={60}
            src={logos?.data?.attributes?.first?.data?.attributes?.url}
            alt={alt}
          />
        </LogoWrapper>
        <i onClick={e => toggleDrawer()(e)}>
          <CloseIcon />
        </i>
      </div>
      <SearchInput />
    </DrawerTopMenuWrapper>
  );
}
